'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.load = load;

var _httpCommon = require('./http-common.js');

/**
 * See reader.js#load for docs.
 * 
 * Browser implementation.
 */
function load(url) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var responseType = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'arraybuffer';

  if (['arraybuffer', 'text'].indexOf(responseType) === -1) {
    throw new Error();
  }
  var headers = options.headers || {};
  return new Promise(function (resolve, reject) {
    var req = new XMLHttpRequest();
    req.open('GET', url);
    req.responseType = responseType;
    var accept = (0, _httpCommon.getAcceptHeader)(options.eagerload);
    req.setRequestHeader('Accept', accept);
    if (headers) {
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = Object.keys(headers)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var header = _step.value;

          req.setRequestHeader(header, headers[header]);
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }
    }

    req.addEventListener('load', function () {
      try {
        if (!(req.status >= 200 && req.status < 300 || req.status === 304)) {
          // as in jquery
          reject(new Error('Resource "' + url + '" not found, HTTP status code: ' + req.status));
          return;
        }

        var data = void 0;
        if (responseType === 'arraybuffer') {
          if (window.TextDecoder) {
            var t0 = new Date();
            data = JSON.parse(new TextDecoder().decode(new DataView(req.response)));
            console.log('JSON decoding: ' + (new Date() - t0) + 'ms');
          } else {
            // load again (from cache) to get correct response type
            // Note we use 'text' and not 'json' as we want to throw parsing errors.
            // With 'json', the response is just 'null'.
            reject({ responseType: 'text' });
            return;
          }
        } else {
          var _t = new Date();
          data = JSON.parse(req.response);
          console.log('JSON decoding (slow path): ' + (new Date() - _t) + 'ms');
        }
        var responseHeaders = parseResponseHeaders(req.getAllResponseHeaders());
        resolve({
          data: data,
          headers: responseHeaders
        });
      } catch (e) {
        reject(e);
      }
    });
    req.addEventListener('error', function () {
      reject(new Error('Network error loading resource at ' + url));
    });

    req.send();
  }).catch(function (e) {
    if (e.responseType) {
      return load(url, headers, e.responseType);
    } else {
      throw e;
    }
  });
}

/**
 * XmlHttpRequest's getAllResponseHeaders() method returns a string of response
 * headers according to the format described here:
 * http://www.w3.org/TR/XMLHttpRequest/#the-getallresponseheaders-method
 * This method parses that string into a user-friendly key/value pair object.
 * Header names are lower-cased.
 * 
 * https://gist.github.com/monsur/706839
 */
function parseResponseHeaders(headerStr) {
  var headers = {};
  if (!headerStr) {
    return headers;
  }
  var headerPairs = headerStr.split('\r\n');
  for (var i = 0; i < headerPairs.length; i++) {
    var headerPair = headerPairs[i];
    // Can't use split() here because it does the wrong thing
    // if the header value has the string ": " in it.
    var index = headerPair.indexOf(': ');
    if (index > 0) {
      var key = headerPair.substring(0, index).toLowerCase();
      var val = headerPair.substring(index + 2);
      headers[key] = val;
    }
  }
  return headers;
}